// Footer Section

function Footer(props) {
  return (
    <div className="flex flex-row justify-center items-center bg-[#31333B]">
      <div className="text-[#F0BF6C] text-2xl h-40 text-center flex flex-row justify-between items-center">
        "Thank You For Scrolling"
      </div>
    </div>
  );
}

export default Footer;
